import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Grid,
} from '@material-ui/core';
import { useApi } from '../useApi';
import { AjaxResult } from '../../enums/ajaxResult';
import { useSnackbar } from 'notistack';
import { EULA_PDF_URL } from '../../constants';

import { useAuth } from "../../features/auth/context";
import { useRefreshTokenRequest } from "../../features/auth/hooks/useRefreshTokenRequest";
import { DocumentPdf } from './DocumentPdf';

export const EulaPopup = ({ children }: { children?: any }) => {
    const { employeeApi } = useApi();
    const { enqueueSnackbar } = useSnackbar();
    const { logout, eulaAccepted } = useAuth();
    const refreshTokenRequest = useRefreshTokenRequest();

    const [eulaPopupOpen, setEulaPopupOpen] = React.useState(eulaAccepted !== true);

    const handleClose = () => {
        logout();
    };

    const handleConfirm = () => {
        employeeApi.acceptEula(true).then((r) => {
            if (r.result === AjaxResult.Success) {
                refreshTokenRequest(true);
                setEulaPopupOpen(false);
            } else {
                enqueueSnackbar('ERROR: cannot update EULA settings');
                logout();
            }
        });
    };

    return (
        <Dialog
            open={eulaPopupOpen}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="md"
            disableBackdropClick
        >
            <DialogTitle id="alert-dialog-title">{'Terms and Conditions'}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    By accessing or using the Service you agree to be bound by these Terms. If you
                    disagree with any part of the terms then you may not access the Service.
                </DialogContentText>
                <Grid container justify="center">
                    <DocumentPdf href={EULA_PDF_URL} />
                </Grid>
            </DialogContent>
            <DialogActions>
                {' '}
                <Button color="primary" variant="contained" onClick={handleConfirm}>
                    Accept
                </Button>
                {/* <div style={{ flex: '1 0 0' }} /> */}
                <Button onClick={handleClose} autoFocus>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};
